import { ErrorMessage } from '@hookform/error-message';
import cn from 'classnames';
import { cloneElement, type FC, type ReactElement } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';

import type { RequestDraft } from '@/components/Glossary/Sections/Glossary.model';
import { _notNil } from '@/littledash';

interface RequestNameFormData {
  name: string;
}

interface NameProps {
  ActionButtons: ReactElement<{ onOk?: () => void; canOk?: boolean }>;
  onSubmit: (data: RequestNameFormData) => void;
  request: RequestDraft;
}

const Name: FC<NameProps> = ({ ActionButtons, onSubmit, request }) => {
  const formMethods = useForm<RequestNameFormData>({
    defaultValues: {
      name: request.name ?? '',
    },
  });

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
  } = formMethods;
  const nameValue = useWatch({ control, name: 'name' });

  return (
    <FormProvider {...formMethods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="pa3 ui-card mw6"
        data-test-component="Name"
        data-test-element="form"
      >
        <div className="mb3">
          <label htmlFor="name">Request name</label>
          <input
            id="name"
            type="text"
            style={{ marginBottom: 0 }}
            className={cn({ input__error: _notNil(errors.name) })}
            data-test-element="name-input"
            {...register('name', {
              required: 'Request name is required',
            })}
          />
          <ErrorMessage
            errors={errors}
            name="name"
            render={({ message }) => <p className="f6 red db pt2">{message}</p>}
          />
        </div>

        {cloneElement(ActionButtons, {
          onOk: handleSubmit(onSubmit),
          canOk: nameValue !== '',
        })}
      </form>
    </FormProvider>
  );
};

export default Name;
